import { Button, Stack, Text } from "@mantine/core";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import {
  selectAutoPipeRoutingConnectionPoints,
  setAutoPipeRoutingPickingConnectionPointInViewerInRedux,
} from "../../pipeRoutingSlice";

export const AutoPipeRoutingConnectionPointStep = () => {
  const dispatch = useAppDispatch();
  const connectionPoints = useAppSelector(selectAutoPipeRoutingConnectionPoints);

  return (
    <Stack gap="sm">
      <Text size="sm" c="dimmed">
        Velg hvor rorene skal kobles til. Når du starter peking i viewer skjules denne modalen til
        punktene er valgt.
      </Text>

      {connectionPoints.length > 0 && (
        <Stack gap={4}>
          <Text size="sm">Valgte punkter: {connectionPoints.length}</Text>
          {connectionPoints.map((connectionPoint, index) => (
            <Text key={`${connectionPoint.join(":")}-${index}`} size="xs" c="dimmed">
              {index + 1}: [{connectionPoint[0]}, {connectionPoint[1]}, {connectionPoint[2]}]
            </Text>
          ))}
        </Stack>
      )}

      <Button onClick={() => dispatch(setAutoPipeRoutingPickingConnectionPointInViewerInRedux(true))}>
        Peka i viewer der vi vil ansluta ror
      </Button>
    </Stack>
  );
};
